module.exports = "/images/home-finance.png?9f007fc4611d92cf15bbcff4ec12efef";